import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { ArrowRight as ArrowRightIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { Box, Button, Paper } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import usePermissions from 'hooks/usePermissions'

import theme from 'theme'
import { routes } from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'

const DocumentTemplatesTable = ({ templates, isLoading }) => {
  const classes = useStyles()
  const history = useHistory()
  const { permitted } = usePermissions()

  const { PRIVACY_POLICIES } = constants.permissions

  const allowedCreate = permitted(PRIVACY_POLICIES.CREATE)

  const handleRedirect = (documentTemplateId) => {
    history.push(
      reverse(routes.documents.generate, {
        documentTemplateId,
      }),
    )
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Box component={Paper} className={classes.card}>
        <PerfectScrollbar
          options={{ wheelPropagation: true, useBothWheelAxes: true }}
        >
          <Table
            emptyMessage="Nenhum modelo de documento foi encontrado."
            isLoading={isLoading}
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell width="50%">Nome</TableCell>
                <TableCell width={allowedCreate ? '20%' : '50%'}>
                  Categoria
                </TableCell>
                {allowedCreate && (
                  <TableCell align="right" width="20%">
                    Ações
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {templates?.map((template) => (
                <TableRow key={template?.id}>
                  <TableCell width="50%" applyNoWrap disableTooltip={false}>
                    {template?.name}
                  </TableCell>
                  <TableCell width="20%" applyNoWrap disableTooltip={false}>
                    {template?.documentCategory?.name}
                  </TableCell>
                  {allowedCreate && (
                    <TableCell align="right" width="20%">
                      <Box display="flex" justifyContent="end">
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => handleRedirect(template.id)}
                          endIcon={<ArrowRightIcon size={18} />}
                        >
                          Usar modelo
                        </Button>
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Box>
    </Box>
  )
}

DocumentTemplatesTable.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
}

export default DocumentTemplatesTable
